import { render, staticRenderFns } from "./UsersubMainPage.vue?vue&type=template&id=1b378760&scoped=true&"
import script from "./UsersubMainPage.vue?vue&type=script&lang=js&"
export * from "./UsersubMainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b378760",
  null
  
)

export default component.exports